import React from 'react';
import { TfiArrowCircleDown } from 'react-icons/tfi';
import Header from './components/Header';
import './App.css';
import SignUp from './components/SignUp';

function App() {
  return (
    <div className="container min-vh-100">
      <Header />
      <div className='container-fluid content'>
        <div className='row'>
          <div className='col-lg-6'>
            <div className='body-content h-100 d-flex flex-column justify-content-center'>
              <h3 className='font-weight-bold text-white'>Make money driving with Bolt</h3>
              <p className='text-white'>Become a Bolt driver, set your schedule and earn extra money by driving!</p>
              <span className='d-none d-lg-inline-block text-white font-weight-bold text-uppercase'>Learn More <TfiArrowCircleDown className='ml-3 font-weight-bold' size={13} color='white' /></span>
            </div>
          </div>
          <div className='col-lg-5'>
            <div className='ml-lg-5'>
              <SignUp />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default App;
